import React from 'react';

export interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  tone?: 'ink' | 'sage';
}

const Chip: React.FC<ChipProps> = ({
  selected = false,
  tone = 'ink',
  className,
  children,
  ...rest
}) => (
  <button
    type="button"
    className={[
      'rr-chip',
      tone === 'sage' ? 'rr-chip-sage' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    aria-pressed={selected}
    {...rest}
  >
    {children}
  </button>
);

export default Chip;
